import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-creative";
import { EffectCreative, Autoplay } from "swiper/modules";
import SliderLeft from "./SliderLeft";
import SliderRight from "./SliderRight";
import { useDispatch, useSelector } from "react-redux"; // Added useSelector
import { retrieveHeaderBanners } from "../../../slices/banners";
import { useNavigate } from "react-router-dom";
import useDeviceType from "../../helpers/GetDevice";
import "./header.css";
export default function Slider() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deviceType = useDeviceType();

  // 1. Grab the dynamic data from the Redux store
  // Based on your slice: initialState = { homeHeader: [], ... }
  const { homeHeader, status } = useSelector((state) => state.banners);

  useEffect(() => {
    dispatch(retrieveHeaderBanners());
  }, [dispatch]);

  // Optional: Show nothing or a skeleton if data is still loading
  if (status === "loading" || homeHeader.length === 0) {
    return <SliderSkeleton deviceType={deviceType} />;
  }

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 p-0">
      <div className="slider-1">
        <div className="wrapper">
          <Swiper
            loop={homeHeader.length > 1} // Only loop if more than 1 banner
            speed={2500}
            autoplay={{
              delay: deviceType === "mobile" ? 2500 : 1200,
              disableOnInteraction: false,
            }}
            effect="creative"
            creativeEffect={{
              prev: { translate: ["-15%", 0, -200], scale: 0.9 },
              next: { translate: ["100%", 0, 0], scale: 1 },
            }}
            modules={[EffectCreative, Autoplay]}
            className="mySwiper"
          >
            {homeHeader.map((slide) => (
              <SwiperSlide key={slide.id || slide._id}>
                <div
                  className="wptb-slider--item"
                  style={{
backgroundImage: `url(${encodeURI(slide.image_url)})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    width: "100%",
                    aspectRatio: deviceType === "mobile" ? "3 / 4" : "16 / 9",
                    height: deviceType === "mobile" ? "35vh" : "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="wptb-slider--inner">
                    <button
                      className="btn btn-two white-opacity creative"
                      onClick={() => navigate(slide.target_url || "/shop")}
                    >
                      <span className="btn-wrap">
                        <span className="text-first">Explore Now</span>
                        <span className="text-second">
                          <i className="bi bi-arrow-up-right" />
                          <i className="bi bi-arrow-up-right" />
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <SliderLeft />
        <SliderRight />
      </div>
    </div>
  );
}

const SliderSkeleton = ({ deviceType }) => (
  <div className="col-lg-12 col-md-12 col-sm-12 p-0">
    <div
      className="skeleton-pulse"
      style={{
        width: "100%",
        aspectRatio: deviceType === "mobile" ? "3 / 4" : "16 / 9",
        height: deviceType === "mobile" ? "35vh" : "auto",
        backgroundColor: "#e0e0e0",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="skeleton-content" style={{ opacity: 0.5 }}>
        <img
          src={require("../../../assets/Images/AeliteZLogoWriteRed.gif")}
          alt="logo"
          style={{ width: "40px", height: "30px" }}
        />{" "}
      </div>
    </div>
  </div>
);
